module.exports = __webpack_public_path__ + "img/art_4_2.d08d77ef.png";